export { FeaturedIcon } from './FeaturedIcon'
export type { FeaturedIconProps } from './types'
